import { ICCEventBusManager } from '@idp/event-bus';
var Events = /** @class */ (function () {
    function Events(serviceNames) {
        this.observableId = ICCEventBusManager.getUUID();
        var currentObservee = {
            observerableId: this.observableId,
            serviceNames: serviceNames,
        };
        ICCEventBusManager.getInstance().configObserverable(currentObservee);
    }
    Events.prototype.fireEvent = function (data, serviceName) {
        ICCEventBusManager.getInstance().notifyObservers(this.observableId, serviceName, data);
    };
    return Events;
}());
export default Events;
//# sourceMappingURL=Events.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/UserInteractionFramework/Events.js
// module id = 2234
// module chunks = 8